var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Chad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M31,5.284C28.818,4.468,26.467,4,24,4s-4.818,0.468-7,1.284v37.431C19.182,43.532,21.533,44,24,44 s4.818-0.468,7-1.284V5.284z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24c0-8.579-5.412-15.875-13-18.716v37.431C38.588,39.875,44,32.579,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M4,24c0,8.579,5.412,15.875,13,18.716V5.284C9.412,8.125,4,15.421,4,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Chad);
export default __webpack_public_path__ + "static/media/icons8-chad.a395db74f5452b6af1b2d26630402d99.svg";
export { ForwardRef as ReactComponent };